<template>
    <div>
        <span
            class="text-xs font-semibold inline-block py-1 px-2 rounded last:mr-0 mr-1"
            :class="status.style">
            {{ status.label }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const effectiveFromDate = computed(() => params?.value?.data.effectiveFromDate + ' 00:00:00')
const effectiveToDate = computed(() => params?.value?.data.effectiveToDate + ' 23:59:59')

const status = computed(() => {
  if (new Date(effectiveFromDate.value) >= new Date()) {
    return {
      label: $t('labels.notActiveYet'),
      style: 'text-warning-600 bg-warning-200'
    }
  }
  if (new Date(effectiveToDate.value) >= new Date() || !params?.value?.data.effectiveToDate) {
    return {
      label: $t('labels.active'),
      style: 'text-success-600 bg-success-200'
    }
  }
  if (new Date(effectiveToDate.value) < new Date()) {
    return {
      label: $t('labels.expired'),
      style: 'text-error-600 bg-error-200'
    }
  }

  return {
    label: '',
    style: ''
  }
})
</script>
